import React from 'react';
import { SettingsSection } from './SettingsLayout';
import { Field2 } from './Field2';
import { useSettings } from './useSettings';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { X } from 'lucide-react';

function ClearableField({ label, value, onChange, onClear, testId, placeholder }) {
    const hasValue = value !== null && value !== undefined && value !== '';
    return (
        <div>
            <div className="flex items-end gap-1.5">
                <div className="flex-1">
                    <Field2 label={label} value={value} onChange={onChange} type="number"
                            placeholder={placeholder} testId={testId} />
                </div>
                <Button type="button" variant="outline" size="icon" className="h-10 w-10 shrink-0" disabled={!hasValue}
                        onClick={onClear} data-testid={`${testId}-clear-btn`} title="Clear">
                    <X size={14} />
                </Button>
            </div>
        </div>
    );
}

export default function ProfitabilitySettings() {
    const { settings, update, save } = useSettings();
    const { can } = useAuth();
    const readOnly = !can('settings', 'edit');

    if (!settings) return <div className="text-[color:var(--bm-text-muted)]">Loading…</div>;

    const clearAndSave = (key) => {
        update(key, null);
        save([key], { [key]: null });
    };

    return (
        <fieldset disabled={readOnly} className={readOnly ? 'opacity-70 pointer-events-none' : ''}>
            <SettingsSection title="Profitability"
                description="Drives the Profitability module — per-client gross profit from invoices and recurring billing, with a cost forecast.">
                <ClearableField label="£ per Emergent credit" value={settings.profitability_credit_unit_cost}
                        onChange={v => update('profitability_credit_unit_cost', v)}
                        onClear={() => clearAndSave('profitability_credit_unit_cost')}
                        placeholder="0.15" testId="profitability-credit-unit-cost-input" />
                <div className="sm:col-span-2 text-[11px] text-[color:var(--bm-text-subtle)] -mt-2">
                    The default rate offered on new cost entries. Past entries keep the rate they were logged with.
                </div>
                <ClearableField label="Default forecast cost (£/mo)" value={settings.profitability_default_forecast_cost}
                        onChange={v => update('profitability_default_forecast_cost', v)}
                        onClear={() => clearAndSave('profitability_default_forecast_cost')}
                        placeholder="0" testId="profitability-default-forecast-cost-input" />
                <div className="sm:col-span-2 text-[11px] text-[color:var(--bm-text-subtle)] -mt-2">
                    Applied to any client without their own forecast override or cost history. Leave blank to fall back to each client's trailing average.
                </div>
                <Field2 label="Trailing average window (months)" value={settings.profitability_trailing_window_months}
                        onChange={v => update('profitability_trailing_window_months', v)} type="number"
                        placeholder="3" testId="profitability-trailing-window-input" />
            </SettingsSection>
        </fieldset>
    );
}
